(() => {
  const loader = document.getElementById('sv-deferred-integrations');
  const companyId = loader?.dataset.klaviyoCompanyId?.trim();

  if (!companyId) return;

  const klaviyoScriptSelector = `script[src*="static.klaviyo.com/onsite/js/${companyId}/klaviyo.js"]`;
  const intentEvents = ['pointerdown', 'touchstart', 'keydown'];
  const configuredFallbackDelay = Number.parseInt(loader.dataset.klaviyoFallbackDelay, 10);
  const fallbackDelay = Number.isFinite(configuredFallbackDelay) && configuredFallbackDelay >= 0
    ? configuredFallbackDelay
    : 10000;
  let fallbackTimer;
  let intersectionObserver;
  let queued = false;
  let started = false;

  const stopWatchingIntent = () => {
    intentEvents.forEach((eventName) => {
      window.removeEventListener(eventName, queueKlaviyo, true);
    });
  };

  const loadKlaviyo = () => {
    if (started || document.querySelector(klaviyoScriptSelector)) {
      started = true;
      return;
    }

    started = true;
    window.clearTimeout(fallbackTimer);
    stopWatchingIntent();
    intersectionObserver?.disconnect();

    const script = document.createElement('script');
    script.async = true;
    script.dataset.svDeferredIntegration = 'klaviyo';
    script.src = `https://static.klaviyo.com/onsite/js/${encodeURIComponent(companyId)}/klaviyo.js?company_id=${encodeURIComponent(companyId)}`;
    document.head.appendChild(script);
  };

  function queueKlaviyo() {
    if (queued || started) return;

    queued = true;
    stopWatchingIntent();

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadKlaviyo, { timeout: 1500 });
    } else {
      window.setTimeout(loadKlaviyo, 350);
    }
  }

  intentEvents.forEach((eventName) => {
    window.addEventListener(eventName, queueKlaviyo, { capture: true, passive: true });
  });

  if ('IntersectionObserver' in window) {
    intersectionObserver = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) queueKlaviyo();
      },
      { rootMargin: '800px 0px' }
    );

    document.querySelectorAll('[class*="klaviyo-form-"]').forEach((form) => {
      intersectionObserver.observe(form);
    });
  }

  const startFallbackTimer = () => {
    if (!queued && !started) fallbackTimer = window.setTimeout(loadKlaviyo, fallbackDelay);
  };

  if (document.readyState === 'complete') {
    startFallbackTimer();
  } else {
    window.addEventListener('load', startFallbackTimer, { once: true });
  }

  window.addEventListener('sv:load-klaviyo', loadKlaviyo);
})();
